import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const replyFeedbackSchema = z.object({
  subject: z.string().min(1).max(200),
  body: z.string().min(1).max(8000),
  // Optional admin-only note saved alongside the reply for future context.
  adminNote: z.string().max(4000).optional(),
});

export class ReplyFeedbackDto extends createZodDto(replyFeedbackSchema) {}
export type ReplyFeedbackPayload = z.infer<typeof replyFeedbackSchema>;
